export default "__VITE_ASSET__SyRjJrvS__"